<template>
  <div class="flex h-screen">
    <NavbarView
      v-if="showNavbar"
      class="w-64 bg-gray-800 text-white sidebar"
    />

    <main class="flex-1 overflow-auto">
      <router-view />
    </main>

    <!-- Notification Center (toujours affiché) -->
    <NotificationCenter v-if="showNavbar" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import NavbarView from './components/NavbarView.vue';
import NotificationCenter from './components/NotificationCenter.vue';

const route = useRoute();

/**
 * Calcul de la visibilité de la Navbar
 * On cache si le chemin est exactement /login ou /waitingRoom
 */
const showNavbar = computed(() => {
  const excludedRoutes = ['/login', '/waitingRoom'];
  return !excludedRoutes.includes(route.path);
});
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.bebas-neue-regular {
  font-family: "Bebas Neue", sans-serif;
}

:root {
  /* BACKGROUNDS */
  --bg-body: #06080F;
  --bg-surface: #0B1020;
  --bg-surface-hover: #131A33;
  --bg-card: #0E1428;

  /* TEXT */
  --text-main: #E8EBF5;
  --text-muted: #8A90B3;

  /* ACCENTS */
  --color-accent: #5B7CFF;
  --color-accent-hover: #3F66FF;

  /* BORDERS */
  --color-border: #1F2A4A;

  /* RADIUS */
  --radius-md: 12px;
}
:root {
  /* --- COULEURS PRIMAIRES (IDENTITÉ DIMOTEC) --- */
  --dimotec-orange: #ed891a;
  --dimotec-blue-light: #fef4e8;
  --dimotec-blue-dark: #c67113;
  
  /* --- PALETTE DE GRIS (INTERFACE DARK & LIGHT) --- */
  --df-bg-body: #f4f7f9;
  --df-bg-card: #ffffff;
  --df-anthracite: #222222; /* Le noir doux de vos headers et boutons */
  --df-text-main: #1a1a1a;
  --df-text-muted: #64748b;
  
  /* --- COULEURS D'ÉTAT (SÉCURITÉ & MAINTENANCE) --- */
  --df-success: #10b981;
  --df-error: #ef4444;
  --df-warning: #f59e0b;
  --df-info: #3b82f6;

  /* --- STRUCTURE & BORDERS --- */
  --df-radius-xl: 1.5rem;   /* 24px */
  --df-radius-2xl: 2.5rem;  /* 40px - Le style arrondi des cartes */
  --df-border: #e2e8f0;
  --df-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.02);
}

/* --- RESET & TYPOGRAPHIE --- */
body {
  background-color: var(--df-bg-body);
  color: var(--df-text-main);
  font-family: 'Plus Jakarta Sans', 'Inter', system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
}

/* --- CLASSES UTILITAIRES SPÉCIFIQUES --- */
.bg-blue-500 { background-color: var(--dimotec-orange); }
.text-dimotec-orange { color: var(--dimotec-orange); }

.card-datafuse {
  background: var(--df-bg-card);
  border-radius: var(--df-radius-2xl);
  border: 1px solid var(--df-border);
  box-shadow: var(--df-shadow);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.card-datafuse:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.08);
}

/* --- BOUTON MAÎTRE --- */
.btn-primary-df {
  background-color: var(--dimotec-orange);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 1rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-primary-df:hover {
  background-color: var(--dimotec-blue-dark);
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(237, 137, 26, 0.2);
}

/* --- ANIMATION DE PULSATION (STATUT ACTIF) --- */
.pulse-green {
  box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  70% { box-shadow: 0 0 0 10px rgba(16, 185, 129, 0); }
  100% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); }
}

body {
  background-color: #ffffff;
  font-family: "Poppins", sans-serif;
  color: rgb(0, 0, 0);
}
p {
  font-weight: normal !important;
  font-family: "Poppins", sans-serif;
}

.purple-button {
      background: linear-gradient(303deg, rgb(246, 241, 252) -197%, rgb(49, 16, 129) 100%);
}

/* Global CSS */
.scrollbar-none::-webkit-scrollbar {
  display: none;
}
.scrollbar-none {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

/* Media query pour écran < 768px (mobile) */
@media (max-width: 767px) {
  .sidebar {
    display: none !important;
  }
  .mobile-navbar {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}

@media (width > 767px) {
  .mobile-navbar {
    display: none;
  }
   .sm\:flex-row {
    display: flex !important;
    flex-direction: row !important; /* aligne en ligne */
  }
  .md\:flex-row {
    display: flex !important;
    flex-direction: row !important; /* aligne en ligne */
  }

}

</style>
